"use client";
import { useResourcePlacementQuery } from "@gettactic/hooks";
import React from "react";

export interface ResourcePlacementLineProps {
  resourceId: string;
}

/** Where the desk sits on its floor's active map: its space and zone. */
export const ResourcePlacementLine: React.FC<ResourcePlacementLineProps> = ({
  resourceId
}) => {
  const { data: placement, isLoading } = useResourcePlacementQuery(resourceId);

  if (isLoading || !placement) return null;

  if (!placement.space) {
    return (
      <p className="-mt-1 mb-2 text-[11px] text-neutral-400">
        Not inside a space on the floor map
      </p>
    );
  }

  return (
    <p className="-mt-1 mb-2 flex flex-wrap items-center gap-x-1 text-[11px] text-neutral-500">
      <span>Space: {placement.space.name}</span>
      {placement.zone ? (
        <>
          <span aria-hidden>·</span>
          <span className="inline-flex items-center gap-1">
            <span
              className="inline-block h-2.5 w-2.5 rounded-sm border border-black/10"
              style={{ backgroundColor: placement.zone.color }}
              aria-hidden
            />
            Zone: {placement.zone.name}
          </span>
        </>
      ) : null}
    </p>
  );
};
